// Mnemonic allows letters, numbers and underscores (_)
// ToDo: Include a max lenght of 100 for all the excel formula validators for name and mnemonics
const CHARACTERS = '0123456789abcdefghijklmnopqrstuvwxyz_';
const regexMnemo = /^[\w]+$/;
const regexMnemoSimSet = /^[\w\>]+$/;
// Alternative Regex: /^[a-zA-Z0-9]_+$/;
const periodKeysRegEx = /^Period_[1-9]\d*$/;
const equationBuilderRegEx = /([\w-]+)/g;

export const sharedRegex = {
  mnemonic: regexMnemo,
  mnemonicAcceptedCharacters: CHARACTERS,
  nameAcceptedCharacters: CHARACTERS + ' ', // Same than mnemonic but allows spaces
  mnemonicSimulationSet: regexMnemoSimSet,
  periodKeysRegEx,
  equationBuilderRegEx
};
